import { catalog } from './Catalog.data';
import { Catalog, RecommandationParameters, RecommandationProduct, RecommandationResponse } from './Catalog.interface';
import { getHeaderCorrelationId, successfulResponseToObject } from '@axa-fr-axion/restful';
import { HEADERS_CORRELATION_NAME } from 'utils';
import { buildRecommandationUrl } from './catalog.utils';

const CONTENT_TYPE = 'application/json';

// Even if the catalog is hardcoded for now, it's hidden behind an async method.
// This way, changing the implementation doesn't impact the components using it.
// If we want to fetch the data from an API, we simply need to change the
// implementation of the following method.
export const fetchCatalog = async (): Promise<Catalog> => {
    return Promise.resolve(catalog);
};

export const fetchRecommandation = (recommandationParameters: RecommandationParameters) => {
    return fetch(
        buildRecommandationUrl(
            recommandationParameters.codeSector,
            recommandationParameters.legalStatus,
            recommandationParameters.income,
            recommandationParameters.numberOfEmployees
        ),
        {
            method: 'GET',
            headers: {
                'Accept': CONTENT_TYPE,
                'Content-Type': CONTENT_TYPE,
                ...getHeaderCorrelationId(HEADERS_CORRELATION_NAME),
            },
        },
    )
        .then((successfulResponseToObject<RecommandationResponse>))
        .then(data => {
            return {
                'incontournables': data.I,
                'complementaires': data.C,
            } as RecommandationProduct;
        });
};
